module.exports = __webpack_public_path__ + "static/media/How Computers Talk Script_1732201630718.959fc0e6.docx";